import { generatePath, Navigate, type NavigateProps, type To, useParams } from 'react-router-dom';

export const NavigateWithParams = ({ to, ...props }: NavigateProps) => {
	// Access current route path parameters, i.e. `id`
	const params = useParams();

	// Construct new target `to` prop string/object
	const toTarget: To =
		typeof to === 'string'
			? generatePath(to, params)
			: {
					...to,
					pathname: generatePath(to.pathname ?? '.', params),
				};

	// Return `Navigate` with augmented `to` prop, pass all other
	// props through
	return <Navigate to={toTarget} {...props} />;
};
